module.exports = __webpack_public_path__ + "img/ac.862d1a36.png";